export const PORTAL_SETTINGS_PATH = '/account/settings/organization/portal';
